import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-missing-building',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex h-screen w-full items-center justify-center bg-main-background p-6">
      <div class="flex w-full max-w-xl flex-col gap-3 rounded-md bg-white p-8 text-center shadow-custom-2">
        <h1 class="oswald-font text-3xl uppercase text-nside-orange-400">Missing Building URL</h1>
        <p class="text-slate-700">
          This app must be opened with a building-scoped URL such as
          <span class="font-semibold">/building/:buildingId/siteAdmin/:boolean/isOrg/:boolean</span>.
        </p>
        <p class="text-sm text-slate-500">
          If this app is loaded in an iframe, update the parent URL so it passes both required params.
        </p>
      </div>
    </div>
  `
})
export class MissingBuildingComponent {}
